import { isLeapYear as fnsIsLeapYear } from "date-fns";

type DateValues = {
    year: number;
    month: number;
    day: number;
    hours: number;
    minutes: number;
    seconds: number;
    milliseconds: number;
}

export const getDateValues = (date: Date): DateValues => {
    return {
        day: date.getDate(),
        month: date.getMonth(),
        year: date.getFullYear(),
        hours: date.getHours(),
        minutes: date.getMinutes(),
        seconds: date.getSeconds(),
        milliseconds: date.getMilliseconds(),
    };
};

export const isLeapYear = (year: number): boolean => {
    return fnsIsLeapYear(new Date(year, 0));
};
